import { Component, Inject } from '@angular/core';
import { FindingService } from '../../finding.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { Finding } from '../../audit.model';

@Component({
  selector: 'iaud-finding-edit-dialog',
  templateUrl: './finding-edit-dialog.component.html',
  styleUrls: ['./finding-edit-dialog.component.scss']
})
export class FindingEditDialogComponent {

  finding: Finding;
  isFormValid: boolean;

  constructor(
    private findingService: FindingService,
    public dialogRef: MatDialogRef<FindingEditDialogComponent>,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.finding = {...data.finding};
  }

  update(): void {
    this.findingService.updateFinding(this.finding)
    .subscribe(response => {
      this.dialogRef.close({findingId: response, success: true});
    }, error => {
      this.snackBar.open(`Error updating Finding: ${error.error.error.message}`, 'Ok', {
        duration: 4000,
      });
    });
  }

  toggleFormValidity(valid: boolean): void {
    this.isFormValid = valid;
  }
}
